import React, {useCallback, useContext} from 'react'
import {BasicDashboardStyles} from './Style'
import {dashboardHooks} from '.'
import RatingBarChart from './RatingBarChart'
import {Grid, IconButton, SvgIcon} from '@mui/material'
import {Img, LightButton} from 'styles/GlobalStyle'
import {Go2} from 'assets'
import {ReactComponent as GoIcon} from 'assets/icons/Go.svg';
import {ReactComponent as Welcome1Icon} from 'assets/icons/Welcome1.svg';
import {ReactComponent as Welcome2Icon} from 'assets/icons/Welcome2.svg';
import {ReactComponent as ClockIcon} from 'assets/icons/Clock.svg';
import {ReactComponent as PlayIcon} from 'assets/icons/Play.svg';
import {KeyboardBackspace} from '@mui/icons-material'
import {useNavigate} from 'react-router-dom'
import {app} from 'router/routes'
import {DashboardContext} from './DashboardContext'
import {useDispatch, useSelector} from 'react-redux'
import {actions} from 'store'
import {alerts, features} from 'keys'
import {isNumber} from 'lodash'
import {videoURL} from 'keys/general'
import {secretStorage} from 'config'
import {ReadingProfilePresentationCard} from './ReadingProfilePresentation'
import {AbilityContext} from 'components/Permissions/Can'
import {permissions} from 'config/ability'
import useFilterRegistry from 'components/FilterManager/hooks/useFilterRegistry'
import CountUp from 'react-countup';
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader'
import DashboardTopSection from './TopSection/DashboardTopSection'

const BasicDashboard = () => {
    const { assessmentFilters, setAssessmentFilters, correctWordsPerMinuteDoughnut, noDataCount } = useContext(DashboardContext)
    const { brokenDisplay } = useSelector(state => state.general)
    const ability = useContext(AbilityContext)

    const filters = useFilterRegistry()
    // משימה z8rp3f97mn - DashboardTopSectionהוחלף ל
    // const cards = dashboardHooks.useDashboardCards()
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const handleFullScreen = () => {
        dispatch(actions.setAlerts({ key: alerts.preview, value: { open: true, props: videoURL, type: "video" } }))
    };

    const goAssessmentChartPage = useCallback(() => {
        navigate(app.assessments, { state: { view: "chart" } });
    }, [])

    const goTestTakers = () => navigate(app.tutorial2)
    const goPerformAssessments = () => navigate(app.tutorial3)

    // המצגת הדינמית מוצגת בשלב זה רק למשתמש הפיילוט ולסופר-יוזרים.
    // ה-hooks של המצגת קוראים ל-endpoints של student_batteries שדורשים בשרת את
    // ההרשאה read__battery — בלעדיה השרת מחזיר 403, וה-interceptor ב-axiosConfig
    // מנקה את הסשן ומחזיר ללוגין. לכן חובה לבדוק גם את ההרשאה (CASL) ולא רק שם משתמש
    const user = secretStorage.getUser()
    const canReadBatteries = ability.can(permissions.read, features.battery)
    const showPresentation = user?.is_superuser ||
        ((user?.username === 'Maayan_BarYochai' || user?.username === 'Adi_A') && canReadBatteries)

    return (
        <BasicDashboardStyles>
            <div className='dashboard-content'>
                <DashboardTopSection />
                {/* <div className='section-cards1'>
                    <Grid container spacing={2}>
                        {cards.map((card, idx) => {
                            const { value, title, icon, text, button } = card

                            return (
                                <Grid item xs={12} sm={6} lg={6} xl={3} key={idx}>
                                    <div className='card'>
                                        <div className='card-header'>
                                            <div >
                                                {title}
                                            </div>
                                            <div className='card-icon'>
                                                <SvgIcon component={icon} inheritViewBox />
                                            </div>
                                        </div>
                                        <div className='card-content'>
                                            {isNumber(value) &&
                                                <div className={`value ${brokenDisplay && "blurred10"}`}>
                                                    <CountUp start={0} end={value} duration={1.5} />
                                                </div>}
                                        </div>
                                        <div className='card-header'>
                                            <div className={`text`}>
                                                {text}
                                            </div>
                                            <div>
                                                <LightButton
                                                    {...button}
                                                    variant="solid"
                                                    action={button.action}
                                                    size="small"
                                                    label={button.label}
                                                    borderColor={button.border}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            )
                        })}
                    </Grid>
                </div> */}
                <div className='section-cards2'>
                    {/* משימה z8rp3f97mn      */}
                    {/* {!showPresentation &&
                        <div className='cartoon-card'>
                            <div className='dashboard-title'>
                                {"ברוכים הבאים למערכת המבדקים"}
                            </div>
                            <div className='dashboard-cartoon'>
                                <Img src={Go2} />
                            </div>
                        </div>} */}
                    <div className='welcome-cards'>
                        {showPresentation ?
                            <div className='welcome-card presentation-full-card'>
                                <ReadingProfilePresentationCard />
                            </div>
                            :
                        <div className='welcome-cards1'>
                            {/* משימה z8rp3f97mn  */}
                            {/* <div className='welcome-card'>
                                <div className='wrap-card-title'>
                                    <div className='card-title'>
                                        <SvgIcon component={Welcome1Icon} inheritViewBox />
                                        {"הכרות קצרה עם המערכת"}
                                    </div>
                                    <div className='card-title'>
                                        {"2:45"}
                                        <SvgIcon component={ClockIcon} inheritViewBox />
                                    </div>
                                </div>
                                <div className='wrap-dashboard-video'>
                                    <IconButton size='large' onClick={handleFullScreen}>
                                        <SvgIcon component={PlayIcon} inheritViewBox />
                                    </IconButton>
                                </div>
                                <div className='card-actions'>
                                    <div className='card-title'>
                                        {"הדרכות"}
                                    </div>
                                    <LightButton
                                        fullWidth
                                        variant="solid2"
                                        className='card-action'
                                        action={goTestTakers}
                                        feature={features.test_takers}
                                        permissionHOC="disabled"
                                        role="read"
                                    >
                                        {"הוספת תלמידים והקצאת מבדקים"}
                                        <SvgIcon component={GoIcon} inheritViewBox />
                                    </LightButton>
                                    <LightButton
                                        fullWidth
                                        variant="solid2"
                                        className='card-action'
                                        action={goPerformAssessments}
                                        feature={features.all_assessments}
                                        permissionHOC="disabled"
                                        role="read"
                                    >
                                        {"ביצוע מבדקים"}
                                        <SvgIcon component={GoIcon} inheritViewBox />
                                    </LightButton>
                                    <div />
                                    <div className='all-data-btn'>
                                        <LightButton
                                            variant="solid"
                                            label={"לכל ההדרכות"}
                                            direction="rtl"
                                            icon={<KeyboardBackspace fontSize='small' />}
                                            size="small"
                                            action={goAssessmentChartPage}
                                            feature={features.tutorials}
                                            permissionHOC="disabled"
                                            role="read"
                                        />
                                    </div>
                                </div>
                            </div> */}
                            <div className='welcome-card details-card'>
                                <div className='wrap-card-title'>
                                    <div className='card-title'>
                                        <SvgIcon component={Welcome2Icon} inheritViewBox />
                                        {"דירוגי הקריאה של כלל התלמידים"}
                                    </div>
                                    <div className='card-title bar-filters'>
                                        <AssessmentFiltersHeader
                                            hideSearchBtn
                                            keys={['']}
                                            loading={correctWordsPerMinuteDoughnut.isFetching}
                                            headerItems={[filters.semester_and_year]}
                                            badge
                                            refetchData={correctWordsPerMinuteDoughnut.refetch}
                                            showLoading={true}
                                            assessmentFilters={assessmentFilters}
                                            setAssessmentFilters={setAssessmentFilters}
                                        />
                                    </div>
                                </div>
                                <RatingBarChart />
                                {/*todo- uncomment after dev "התלפגות ביצועים" screen*/}
                                {/*<div className='all-data-btn'>*/}
                                {/*    <LightButton*/}
                                {/*        variant="solid"*/}
                                {/*        label={"לכל הנתונים"}*/}
                                {/*        direction="rtl"*/}
                                {/*        icon={<KeyboardBackspace fontSize='small' />}*/}
                                {/*        size="small"*/}
                                {/*        feature={features.assessments}*/}
                                {/*        permissionHOC="hidden"*/}
                                {/*        role="read"*/}
                                {/*        action={goAssessmentChartPage}*/}
                                {/*    />*/}
                                {/*</div>*/}
                            </div>
                            {/* TODO: קוביית התרגולים - בהמשך */}
                            <div className='practice-card' />
                        </div>}
                    </div>
                </div>
            </div>
        </BasicDashboardStyles >
    )
}

export default BasicDashboard